export const servicesConstants = {
  GET_SERVICES: 'services/GET_SERVICES',
  SET_SERVICES: 'services/SET_SERVICES',
  CLEAR_SERVICES: 'services/CLEAR_SERVICES',
};
